import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=3b979c66"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=3b979c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports